/*
 * 配置编译环境和线上环境之间的切换
 * 以及静态变量
 * baseUrl: 域名地址
 * routerMode: 路由模式
 */
let baseUrl = "";
let fenceUrl = "";
let businessUrl = "";
let bw = "";
let shareUrl = "";
let geUrl = "";
let miniUrl = "";
let routerMode = "history";
let DEBUG = false;
let cancleHTTP = [];//取消请求头设置；
let CommercialUrl = "";//商财测试地址（请求公司列表）
let b4sUrl = "";
let longMini = "";
let targetUrl = "";
let marbasUrl = "";
let aiUrl = "";
let ai2Url = "";
let kfUrl = "";
let subAppUrl = ""; //智能助手子应用地址
let dpUrl = ""; //数据中台前端地址（data-platform-web，知识库管理跳转）

if (process.env.NODE_ENV == 'development') { //测试地址（通过devServer proxy转发，解决跨域）
  baseUrl = "";
  fenceUrl = "http://39.105.107.58:8083";
  businessUrl = "http://bussitest.n-cars.com.cn/home?token=";
  bw = "http://test.api.adpush.jiuyuandashi.com.cn";
  shareUrl = "http://fx.jiuyuandashi.com.cn";
  geUrl = "";
  miniUrl = "http://mini.jiuyuandashi.com.cn/rescue-master/api/";
  DEBUG = true;
  CommercialUrl = "";
  b4sUrl = "http://test.api.b.jiuyuandashi.com.cn";
  longMini = "https://t.api.mini.jiuyuandashi.com.cn/video/api";
  targetUrl = "http://test.api.guide.jiuyuandashi.com.cn/rescue-master/target-guide/api";
  marbasUrl = "http://test.marbas.jiuyuandashi.com.cn";
  aiUrl = "http://test.api.adpush.jiuyuandashi.com.cn";
  ai2Url = "";
  kfUrl = ""; // 本地开发：走 config/index.js proxy 转发到 localhost
  subAppUrl = "http://localhost:3000";
  dpUrl = "http://localhost:8080"; //本地开发：data-platform-web vite dev server
} else if (process.env.NODE_ENV == 'testing') { //测试地址
  baseUrl = "http://test.api.account.jiuyuandashi.com.cn";
  fenceUrl = "http://39.105.107.58:8083";
  businessUrl = "http://bussitest.n-cars.com.cn/home?token=";
  bw = "http://test.api.adpush.jiuyuandashi.com.cn";
  shareUrl = "http://fx.jiuyuandashi.com.cn";
  geUrl = "http://rescue.n-cars.com.cn";
  miniUrl = "http://mini.jiuyuandashi.com.cn/rescue-master/api/";
  DEBUG = false;
  CommercialUrl = "http://test.api.buss.jiuyuandashi.com.cn";
  b4sUrl = "http://test.api.b.jiuyuandashi.com.cn";
  longMini = "https://t.api.mini.jiuyuandashi.com.cn/video/api";
  targetUrl = "http://test.api.guide.jiuyuandashi.com.cn/rescue-master/target-guide/api";
  marbasUrl = "http://test.marbas.jiuyuandashi.com.cn";
  aiUrl = "http://test.api.adpush.jiuyuandashi.com.cn";
  ai2Url = "http://test.api.robot.jiuyuandashi.com.cn";
  kfUrl = "http://test.api.kf.jiuyuandashi.com.cn"; // 测试 Python 后端服务器
  subAppUrl = "http://test.agent.jiuyuandashi.com.cn";
  dpUrl = "http://test.dataplatform.jiuyuandashi.com.cn"; // data-platform-web 测试环境地址
} else if (process.env.NODE_ENV == 'production') { //生产地址
  baseUrl = "https://api.account.jiuyuandashi.com.cn";
  fenceUrl = "https://fence.jiuyuandashi.com.cn";
  businessUrl = "https://bussi.n-cars.com.cn/home?token=";
  bw = "https://api.adpush.jiuyuandashi.com.cn";
  shareUrl = "http://share.jiuyuandashi.com.cn";
  geUrl = "https://c.jiuyuandashi.com.cn";
  miniUrl = "https://api.mini.jiuyuandashi.com.cn/rescue-master/api/";
  DEBUG = false;
  CommercialUrl = "https://bussi.n-cars.com.cn";
  b4sUrl = "https://api.b.jiuyuandashi.com.cn";
  targetUrl = "https://api.guide.jiuyuandashi.com.cn/rescue-master/target-guide/api";
  marbasUrl = "https://pro.marbas.jiuyuandashi.com.cn";
  aiUrl = "https://api.adpush.jiuyuandashi.com.cn";
  ai2Url = "https://api.robot.jiuyuandashi.com.cn";
  kfUrl = "https://api.kf.jiuyuandashi.com.cn"; // 正式 Python 后端服务器
  subAppUrl = "https://agent.jiuyuandashi.com.cn"; // 正式智能助手子应用地址
  dpUrl = "https://dataplatform.jiuyuandashi.com.cn"; // data-platform-web 正式环境地址
}

export default {
  baseUrl,
  fenceUrl,
  businessUrl,
  bw,
  shareUrl,
  geUrl,
  miniUrl,
  routerMode,
  DEBUG,
  cancleHTTP,
  CommercialUrl,
  b4sUrl,
  longMini,
  targetUrl,
  marbasUrl,
  aiUrl,
  ai2Url,
  kfUrl,
  subAppUrl,
  dpUrl,
}



// WEBPACK FOOTER //
// ./src/common/env.js